const events = [
  {
    id: 1,
    event_public_id: "ev21one",
    title:
      'Webinar "Recognizing Generic Terms in Geographical Names from Local Languages"',
    event_date: "2021-08-30",
    place: "Virtual Meeting",
    description:
      "The event was held on Monday, August 30, 2021. The first speaker, a toponymy expert from the University of Amsterdam, FerjanOrmeling describes the relationship between toponymy and language,where there is always a story behind the current geographic name,as part of the cultural heritage that must be preserved. Thesecond speaker, a toponymy expert from the University ofIndonesia, Multamia RMT Lauder discussed language maps andtoponymy terms in the local Indonesian language. The thirdspeaker, Professional Lecturer at the University of thePhilippines Diliman, Meliton B. Juanico explained about the linkbetween local languages and toponyms in the Philippines. The lastspeaker, Head of the Indonesian Geospatial Information Agency,Muh. Aris Marfai explained about Geospatial information andstandardization of geographic names in Indonesia.",
    image: "/images/events/ev21oneposter.jpg",
    categories_id: 1,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/embed/naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],
  },
  {
    id: 2,
    event_public_id: "ev18one",
    title:
      "The 1st Regional Training Program in Toponymy including Marine Toponymy",
    event_date: "2018-03-19",
    place: "Manila - Philippines",
    description: "Regional training program on toponymy.",
    image: "/images/events/ev18oneposter.jpg",
    categories_id: 1,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/watch?v=naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],
  },
  {
    id: 3,
    event_public_id: "ev15one",
    title: 'Seminar "Toponym: Identity and National Identity"',
    event_date: "2015-05-28",
    place: "Bali - Indonesia",
    description: "Seminar on toponymy and national identity.",
    image: "/images/events/ev15oneposter.jpg",
    categories_id: 1,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/watch?v=naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],
  },
  {
    id: 4,
    event_public_id: "ev15two",
    title:
      'Seminar "Geospatial Information Society Discussed about Mechanism of Standardization of Topographical Names"',
    event_date: "2015-11-03",
    place: "Malang - Indonesia",
    description: "Seminar on standardization of topographical names.",
    image: "/images/events/ev15twoposter.jpg",
    categories_id: 1,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/embed/naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],
  },
  {
    id: 5,
    event_public_id: "ev13one",
    title: "Seminar ”Place names preserving Cultural Heritage”",
    event_date: "2013-05-13",
    place: "Brunei Darussalam",
    description: "Seminar on place names and cultural heritage.",
    image: "/images/events/ev13oneposter.jpg",
    categories_id: 2,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/embed/naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],
  },
  {
    id: 6,
    event_public_id: "ev13two",
    title:
      'National Seminar on Toponymic "Peran Toponimi dalam Pelestarian Budaya Bangsa dan Pembangunan Nasional”',
    event_date: "2013-06-25",
    place: "Bandung - Indonesia",
    description: "National seminar on toponymy.",
    image: "/images/events/ev13twoposter.jpg",
    categories_id: 2,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/embed/naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],
  },
  {
    id: 7,
    event_public_id: "ev12one",
    title: "UNGEGN Training Course",
    event_date: "2012-09-17",
    place: "Yogyakarta - Indonesia",
    description: "UNGEGN training course.",
    image: "/images/events/ev12oneposter.jpg",
    categories_id: 2,
    status_id: 1,
    user_id: 1,
    recording_link: "https://www.youtube.com/embed/naz0-szzYXk",
    documents: 
    [ 
      { 
        id: 6, 
        document_name: "Country Report_INDONESIA_3rdUNGEGN_ASE_Division2015.pdf", 
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      }, 
      { id: 7,
        document_name: "CountryReport_4thDM_Brunei Darussalam.pdf",
        file_url: "/docs/V1.4 - Prosedur Pengamanan Insiden Keamanan Informasi.pdf" 
      } 
    ],
    related_links: [
      {
        id: 1,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 2,
        display_name: "UNGEGN Training Course", 
        url: "https://www.big.go.id" 
      },
      {
        id: 3,
        display_name: "UNGEGN Training Course",
        url: "https://www.big.go.id" 
      },
    ],  
  },
];

export default events;
